import {Component, OnInit} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ImmutableListRepositoryService} from '../immutable-list-repository.service';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-gelios-immutable-list-field',
  templateUrl: './gelios-immutable-list-field.component.html'
})
export class GeliosImmutableListFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  itemChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  tooltiptextVisible = false;
  tooltiptextHidden = true;
  tr: BehaviorSubject<string> = new BehaviorSubject<string>('');

  onValueChange($event) {
    super.onValueChange($event);
    this.tooltiptextVisible = false;
    this.tr.next(this.immutableListsService.getItemById(this.reflexiveField.immutableList.name, $event));
    this.itemChanged.next(true);
  }
  onClick() {
    this.itemChanged.next(true);
  }

  pricePlanPartTooltipVisible() {
    this.tooltiptextVisible = true;
  }

  pricePlanPartTooltipHidden() {
    this.tooltiptextVisible = false;
  }

  public items: Observable <any>;
  constructor(
    protected immutableListsService: ImmutableListRepositoryService,
    protected translateService: TranslateService
  ) {
    super(translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.fetchItems();
    this.tr.next(this.immutableListsService.getItemById(this.reflexiveField.immutableList.name, this.formGroup.get(this.fieldName).value));
    if (this.reflexiveField.immutableList.filterBehaviorSubject) {
      this.reflexiveField.immutableList.filterBehaviorSubject.subscribe(
        availableIds => this.fetchItems(availableIds));
    }
  }

  protected fetchItems(availableIds?: Array<number | string>): any {
    const data: Observable<Array<{ id: any, name: any }>> = this.immutableListsService.getList(this.reflexiveField.immutableList.name);
    if (availableIds) {
      this.items = data.pipe(
        map(result => result.filter(el => availableIds.includes(el.id))),
      );
    } else {
      this.items = data;
    }
  }

  public keyField() {
    return this.reflexiveField.immutableList.keyField ?
      this.reflexiveField.immutableList.keyField : 'id';
  }
  public hintField() {
    return this.reflexiveField.immutableList.hintField ?
      this.reflexiveField.immutableList.hintField : 'hint';
  }
  public displayedField() {
    return this.reflexiveField.immutableList.displayedField ?
      this.reflexiveField.immutableList.displayedField : 'name';
  }
  public groupByField() {
    return this.reflexiveField.immutableList.groupByField ?
      this.reflexiveField.immutableList.groupByField : undefined;
  }
}
